import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */

/* template */
var __vue_render__ = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"carousel__slide"},[_vm._t("default")],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-7d0fb7a4_0", { source: ".carousel__slide[data-v-7d0fb7a4]{scroll-snap-align:start;flex-shrink:0;margin-right:12px;width:80%}.carousel__slide[data-v-7d0fb7a4]:only-child{width:100%}.carousel__slide[data-v-7d0fb7a4]:last-child{margin-right:0}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-7d0fb7a4";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = true;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
